import React, { useState } from "react";
import { QrCodeService } from "../services/QrCodeService";
import "./RawFruit.css";

const GenerateQrCode: React.FC = () => {
  const [qrRow, setQrRow] = useState<number>(2); // Default rows
  const [qrCol, setQrCol] = useState<number>(2); // Default columns
  const [qrCopy, setQrCopy] = useState<number>(2); // Default columns
  const [totalQrCodes, setTotalQrCodes] = useState<number>(10); // Default total QR codes
  const [formSubmitting, setFormSubmitting] = useState(false);

  const handleGeneratePdf = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormSubmitting(true);

    try {
      const response = await QrCodeService.generateQrCodePdf({
        totalQrCodes,
        qrRow,
        qrCol,
        qrCopy,
      });
    } catch (error) {
      console.error("Error generating QR code PDF:", error);
      alert("Failed to generate QR code PDF. Please try again.");
    } finally {
      setFormSubmitting(false);
    }
  };

  return (
    <div className="page">
      <div className="container">
        <h1 className="title">Generate QR Codes</h1>
        <form onSubmit={handleGeneratePdf} className="form">
          <label className="label">Number of Rows:</label>
          <input
            type="number"
            value={qrRow}
            onChange={(e) => setQrRow(parseInt(e.target.value, 10))}
            className="input"
            min={1}
            placeholder="Enter number of rows"
          />

          <label className="label">Number of Columns:</label>
          <input
            type="number"
            value={qrCol}
            onChange={(e) => setQrCol(parseInt(e.target.value, 10))}
            className="input"
            min={1}
            placeholder="Enter number of columns"
          />

          <label className="label">Number of Copies:</label>
          <input
            type="number"
            value={qrCopy}
            onChange={(e) => setQrCopy(parseInt(e.target.value, 10))}
            className="input"
            min={1}
            placeholder="Enter number of copies of each qr code"
          />

          <label className="label">Total QR Codes:</label>
          <input
            type="number"
            value={totalQrCodes}
            onChange={(e) => setTotalQrCodes(parseInt(e.target.value, 10))}
            className="input"
            min={1}
            placeholder="Enter total number of QR codes"
          />

          <button
            type="submit"
            className="button"
            disabled={formSubmitting}
          >
            {formSubmitting ? "Generating..." : "Generate PDF"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default GenerateQrCode;
